import { measuredUsingConfigFor as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

const getMeasuredUsingConfig = (prefix: string) => {
  const initialBalance = wrap(`${prefix}.Equipment.InitialBalance`);
  const washedDryBalance = wrap(`${prefix}.Masses.MeasuredWashedConstantDryMass.Equipment.DryMassBalance`);
  const screeningsDryBalance = wrap(`${prefix}.Masses.MeasuredScreeningsConstantDryMass.Equipment.DryMassBalance`);
  return {
    [`${prefix}.Masses.InitialDryMass`]: initialBalance,
    [`${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTrays.ContainerMass`]: washedDryBalance,
    [`${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTrays.DryMassReadings.DrySoilAndContainerMass`]:
      washedDryBalance,
    [`${prefix}.Masses.MeasuredScreeningsConstantDryMass.DryingTrays.DryMassReadings.DrySoilAndContainerMass`]:
      screeningsDryBalance,
  };
};

export default getMeasuredUsingConfig;
